import {useLazyQuery, gql} from "@apollo/client";
import {getBrowser} from "../common/common";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getPdfDocumentBySlug ($slugs: [String!], $locale: String!){
    pdfDocumentCollection(where: { slug_in: $slugs}, locale: $locale) {
      items {
        slug
        pdfDocumentCollection {
          items {
            title
            url
          }
        }
      }
    }
  }
`;

export const usePdfDocumentsBySlug = () => {
    const {logger} = useLogger();
    const [getPdfDocuments, { loading, data, error }] = useLazyQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    let pdfDocuments = null;
    if (data) {
        pdfDocuments = data?.pdfDocumentCollection?.items;
    }

    if (error?.message) {
        logger(error?.message, "error", "usePdfDocumentsBySlug", error?.stack);
    }

    return {
        pdfDocuments,
        getPdfDocuments,
        pdfDocumentLoading: loading
    };
};
